"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_common.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalResaleApplication = exports.LegacyPortalResaleListing = exports.LegacyPortalResaleRound = exports.LegacyPortalResaleApplicationStatus = exports.LegacyPortalResaleRoundStatus = exports.LegacyPortalResaleListingStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * リセール出品ステータス
 *
 * @generated from enum spwn.resale.v1.LegacyPortalResaleListingStatus
 */
var LegacyPortalResaleListingStatus;
(function (LegacyPortalResaleListingStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 出品中
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_LISTING = 1;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["LISTING"] = 1] = "LISTING";
    /**
     * キャンセル
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_CANCELED = 2;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["CANCELED"] = 2] = "CANCELED";
    /**
     * 完了
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_COMPLETED = 3;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["COMPLETED"] = 3] = "COMPLETED";
})(LegacyPortalResaleListingStatus || (exports.LegacyPortalResaleListingStatus = LegacyPortalResaleListingStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalResaleListingStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalResaleListingStatus, "spwn.resale.v1.LegacyPortalResaleListingStatus", [
    { no: 0, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_LISTING" },
    { no: 2, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_CANCELED" },
    { no: 3, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_COMPLETED" },
]);
/**
 * リセール回・期間ステータス（受付前・受付中・受付終了など）
 * ※DBには保存せず、開始・終了日時等を元にバックエンドで算出
 *
 * @generated from enum spwn.resale.v1.LegacyPortalResaleRoundStatus
 */
var LegacyPortalResaleRoundStatus;
(function (LegacyPortalResaleRoundStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_RESALE_ROUND_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalResaleRoundStatus[LegacyPortalResaleRoundStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 受付前
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_ROUND_STATUS_UPCOMING = 1;
     */
    LegacyPortalResaleRoundStatus[LegacyPortalResaleRoundStatus["UPCOMING"] = 1] = "UPCOMING";
    /**
     * 受付中
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_ROUND_STATUS_OPEN = 2;
     */
    LegacyPortalResaleRoundStatus[LegacyPortalResaleRoundStatus["OPEN"] = 2] = "OPEN";
    /**
     * 受付終了
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_ROUND_STATUS_CLOSED = 3;
     */
    LegacyPortalResaleRoundStatus[LegacyPortalResaleRoundStatus["CLOSED"] = 3] = "CLOSED";
})(LegacyPortalResaleRoundStatus || (exports.LegacyPortalResaleRoundStatus = LegacyPortalResaleRoundStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalResaleRoundStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalResaleRoundStatus, "spwn.resale.v1.LegacyPortalResaleRoundStatus", [
    { no: 0, name: "LEGACY_PORTAL_RESALE_ROUND_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_RESALE_ROUND_STATUS_UPCOMING" },
    { no: 2, name: "LEGACY_PORTAL_RESALE_ROUND_STATUS_OPEN" },
    { no: 3, name: "LEGACY_PORTAL_RESALE_ROUND_STATUS_CLOSED" },
]);
/**
 * リセール申込ステータス（申込者個人の当落・申込状態）
 *
 * @generated from enum spwn.resale.v1.LegacyPortalResaleApplicationStatus
 */
var LegacyPortalResaleApplicationStatus;
(function (LegacyPortalResaleApplicationStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 申込中
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_APPLIED = 1;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["APPLIED"] = 1] = "APPLIED";
    /**
     * 当選
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_WON = 2;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["WON"] = 2] = "WON";
    /**
     * 落選
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_LOST = 3;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["LOST"] = 3] = "LOST";
    /**
     * キャンセル
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_CANCELED = 4;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["CANCELED"] = 4] = "CANCELED";
})(LegacyPortalResaleApplicationStatus || (exports.LegacyPortalResaleApplicationStatus = LegacyPortalResaleApplicationStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalResaleApplicationStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalResaleApplicationStatus, "spwn.resale.v1.LegacyPortalResaleApplicationStatus", [
    { no: 0, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_APPLIED" },
    { no: 2, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_WON" },
    { no: 3, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_LOST" },
    { no: 4, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_CANCELED" },
]);
/**
 * リセール期間・回設定エンティティ
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleRound
 */
class LegacyPortalResaleRound extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_round_id = 1;
         */
        this.resaleRoundId = "";
        /**
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 3;
         */
        this.ticketId = "";
        /**
         * 出品受付開始日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listing_start_at = 4;
         */
        this.listingStartAt = protobuf_1.protoInt64.zero;
        /**
         * 出品受付終了日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listing_end_at = 5;
         */
        this.listingEndAt = protobuf_1.protoInt64.zero;
        /**
         * 申込受付開始日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 application_start_at = 6;
         */
        this.applicationStartAt = protobuf_1.protoInt64.zero;
        /**
         * 申込受付終了日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 application_end_at = 7;
         */
        this.applicationEndAt = protobuf_1.protoInt64.zero;
        /**
         * 当落発表日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 lottery_date = 8;
         */
        this.lotteryDate = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleRound, a, b);
    }
}
exports.LegacyPortalResaleRound = LegacyPortalResaleRound;
LegacyPortalResaleRound.runtime = protobuf_1.proto3;
LegacyPortalResaleRound.typeName = "spwn.resale.v1.LegacyPortalResaleRound";
LegacyPortalResaleRound.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "listing_start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "listing_end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "application_start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "application_end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "lottery_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * リセール出品エンティティ
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleListing
 */
class LegacyPortalResaleListing extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_listing_id = 1;
         */
        this.resaleListingId = "";
        /**
         * @generated from field: string resale_round_id = 2;
         */
        this.resaleRoundId = "";
        /**
         * @generated from field: string order_id = 3;
         */
        this.orderId = "";
        /**
         * @generated from field: string ticket_id = 4;
         */
        this.ticketId = "";
        /**
         * @generated from field: spwn.resale.v1.LegacyPortalResaleListingStatus status = 5;
         */
        this.status = LegacyPortalResaleListingStatus.UNSPECIFIED;
        /**
         * @generated from field: bool is_matched = 6;
         */
        this.isMatched = false;
        /**
         * 出品日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listed_at = 7;
         */
        this.listedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleListing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleListing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleListing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleListing, a, b);
    }
}
exports.LegacyPortalResaleListing = LegacyPortalResaleListing;
LegacyPortalResaleListing.runtime = protobuf_1.proto3;
LegacyPortalResaleListing.typeName = "spwn.resale.v1.LegacyPortalResaleListing";
LegacyPortalResaleListing.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_listing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalResaleListingStatus) },
    { no: 6, name: "is_matched", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "listed_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "canceled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * リセール申込エンティティ
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleApplication
 */
class LegacyPortalResaleApplication extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_application_id = 1;
         */
        this.resaleApplicationId = "";
        /**
         * @generated from field: string resale_round_id = 2;
         */
        this.resaleRoundId = "";
        /**
         * @generated from field: string ticket_id = 3;
         */
        this.ticketId = "";
        /**
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        /**
         * @generated from field: spwn.resale.v1.LegacyPortalResaleApplicationStatus status = 5;
         */
        this.status = LegacyPortalResaleApplicationStatus.UNSPECIFIED;
        /**
         * 申込日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 applied_at = 6;
         */
        this.appliedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleApplication().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleApplication().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleApplication().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleApplication, a, b);
    }
}
exports.LegacyPortalResaleApplication = LegacyPortalResaleApplication;
LegacyPortalResaleApplication.runtime = protobuf_1.proto3;
LegacyPortalResaleApplication.typeName = "spwn.resale.v1.LegacyPortalResaleApplication";
LegacyPortalResaleApplication.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalResaleApplicationStatus) },
    { no: 6, name: "applied_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "canceled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map